import { useTranslation } from 'react-i18next';

interface StaffOnlySpaceTypeSelectorProps {
  selectedSpaceType: string;
  onSelectShower: () => void;
  onSelectPrivateRoom: () => void;
}

export const StaffOnlySpaceTypeSelector = ({
  onSelectShower,
  onSelectPrivateRoom,
  selectedSpaceType,
}: StaffOnlySpaceTypeSelectorProps) => {
  const { t } = useTranslation();

  return (
    <div className="e-search__row">
      <div className="e-search__service">
        <div className="e-search__service-list">
          <label
            className={`e-search__service-item ${selectedSpaceType !== 'shower_room' ? 'is-hidden' : ''}`}
          >
            <input
              className="e-search__service-input"
              type="radio"
              onClick={onSelectShower}
            />
            <span className="e-search__service-body">
              <span className="e-search__service-icon-wrap">
                <img
                  className="e-search__service-icon"
                  src={
                    selectedSpaceType === 'shower_room'
                      ? '/Icon_Shower.png'
                      : '/Icon_Shower_Off.png'
                  }
                  alt={t('staffOnly.serviceType.shower')}
                />
              </span>
              <span className="e-search__service-label">
                {t('staffOnly.serviceType.shower')}
              </span>
            </span>
          </label>

          <label
            className={`e-search__service-item ${selectedSpaceType !== 'private_room' ? 'is-hidden' : ''}`}
          >
            <input
              className="e-search__service-input"
              type="radio"
              onClick={onSelectPrivateRoom}
            />
            <span className="e-search__service-body">
              <span className="e-search__service-icon-wrap">
                <img
                  className="e-search__service-icon"
                  src={
                    selectedSpaceType === 'private_room'
                      ? '/Icon_Booth.png'
                      : '/Icon_Booth_Off.png'
                  }
                  alt={t('staffOnly.serviceType.booth')}
                />
              </span>
              <span className="e-search__service-label">
                {t('staffOnly.serviceType.booth')}
              </span>
            </span>
          </label>
        </div>
      </div>
    </div>
  );
};
